import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../theme';

const usePortraitStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      videoWrap: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        height: 225,
        borderRadius: 5,
        overflow: 'hidden',
        cursor: 'pointer',
        background:
          background === 'Dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,

        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          height: '90%',
          background:
            background === 'Dark'
              ? 'linear-gradient(0deg, rgba(35, 32, 46, 1) 0%, rgba(36, 34, 47, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat'
              : 'linear-gradient(0deg, rgba(27, 25, 37, 1) 0%, rgba(28, 27, 38, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat',
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
        },

        [theme.breakpoints.up('sm')]: {
          height: 315,

          '&:hover': {
            '& $videoImg': {
              height: '110%',
            },
          },
        },
      },
      videoImg: {
        position: 'absolute',
        right: '50%',
        bottom: '50%',
        height: '100%',
        transform: 'translate(50%, 50%)',
        transition: 'height .3s ease',
      },
      btnWrap: {
        cursor: 'pointer',
        position: 'absolute',
        transform: 'translate(-40%, -60%)',
        background: 'rgba(29, 29, 41, 0.501961);',
        top: '50%',
        left: '50%',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        width: 50,
        height: 50,
        [theme.breakpoints.up('md')]: {
          width: 70,
          height: 70,
        },
      },
      btn: {
        width: 24,
        height: 28,
        marginLeft: 2,
        [theme.breakpoints.up('md')]: {
          width: 35,
          height: 40,
          marginLeft: 4,
        },
      },
      title: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '17px',
        margin: '0 17px 17px 17px',
        zIndex: 4,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '3',
        '-webkit-box-orient': 'vertical',
        width: '75%',
        maxHeight: 72,
        [theme.breakpoints.up('sm')]: {
          fontSize: 20,
          lineHeight: '24px',
          margin: '0 23px 23px 23px',
        },
      },
    }),
  );

export const landscapeStyles = (background, videoWidth) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      videoWrap: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        height: 240,
        borderRadius: 5,
        overflow: 'hidden',
        background:
          background === 'Dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
        boxShadow:
          background === 'Dark' ? '0px 3px 6px rgba(0,0,0,0.3)' : '0px 3px 6px rgba(0,0,0,0.1)',

        [theme.breakpoints.up('md')]: {
          height: '100%',

          '&:hover': {
            '&::after': {
              height: 242,
              bottom: 132,
            },

            '& $imgWrap': {
              '&::after': {
                height: 180,
              },
            },

            '& $title': {
              width: `${videoWidth + videoWidth * 0.2 - 27 * 2}px`,
            },

            '& $description': {
              width: `${videoWidth + videoWidth * 0.2 - 27 * 2}px`,
              fontSize: 16,
              lineHeight: '22px',
              marginBottom: 9,
              overflow: 'hidden',
              whiteSpace: 'inherit',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              '-webkit-line-clamp': '3',
              '-webkit-box-orient': 'vertical',
            },
          },
        },
      },
      link: {
        color: 'inherit',
      },
      imgWrap: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 198,
        transition: 'none',
        cursor: 'pointer',

        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          left: 0,
          bottom: -3,
          width: '100%',
          height: 133,
          background:
            background === 'Dark'
              ? 'linear-gradient(0deg, rgba(35, 32, 46, 1) 0%, rgba(36, 34, 47, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat'
              : 'linear-gradient(0deg, rgba(27, 25, 37, 1) 0%, rgba(28, 27, 38, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat',
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
          zIndex: 0,
        },

        [theme.breakpoints.up('md')]: {
          height: 246,
        },
      },
      lazyWrapper: {
        width: '100%',
        height: '100%',
      },
      videoImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      btnWrap: {
        cursor: 'pointer',
        position: 'absolute',
        transform: 'translate(-50%, -60%)',
        background: 'rgba(29, 29, 41, 0.501961);',
        top: '50%',
        left: '50%',
        zIndex: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        width: 50,
        height: 50,
        [theme.breakpoints.up('md')]: {
          width: 70,
          height: 70,
        },
      },
      btn: {
        width: 24,
        height: 28,
        marginLeft: 2,
        [theme.breakpoints.up('md')]: {
          width: 35,
          height: 40,
          marginLeft: 4,
        },
      },
      catDifWrap: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        marginBottom: 12,
        zIndex: 1,

        [theme.breakpoints.up('md')]: {
          padding: '0 32px',
        },
      },
      category: {
        marginRight: 10,
      },
      textWrap: {
        padding: '0 24px 24px 24px',
        zIndex: 1,
        [theme.breakpoints.up('md')]: {
          padding: '0 32px 32px 32px',
        },
      },
      title: {
        width: `${videoWidth - 27 * 2}px`,
        fontSize: 18,
        lineHeight: '22px',
        fontWeight: 'bold',
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        marginBottom: 12,
        cursor: 'pointer',
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          lineHeight: '28px',
        },
      },
      description: {
        display: 'none',
      },
      duration: {
        fontSize: 12,
        lineHeight: '15px',
        color: colorsPalette.violet,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
          lineHeight: '18px',
        },
      },
      expertLink: {
        color: colorsPalette.violet,
      },
    });
  });

export default usePortraitStyles;
